import { Form } from 'antd';
import type { Rule } from 'antd/es/form';
import type { ReactNode } from 'react';
import styles from './form.module.scss';

type FormFieldProps = {
    label: string;
    name: string;
    required?: boolean;
    rules?: Rule[];
    children: ReactNode;
};

export const FormField = ({
    label,
    name,
    required = false,
    rules = [],
    children,
}: FormFieldProps) => {
    const mergedRules: Rule[] = [...rules];
    if (required && !mergedRules.some((r: any) => r.required)) {
        mergedRules.unshift({ required: true, message: `${label}を入力してください` });
    }

    return (
        <div className={styles.fieldWrapper}>
            <span className={styles.label}>
                {label}
                {required && <span className={styles.requiredBadge}>必須</span>}
            </span>
            <Form.Item name={name} rules={mergedRules} noStyle={false}>
                {children}
            </Form.Item>
        </div>
    );
};
